import { authClient, API } from '../index'

// Count all Cupones
export const countCupones = () => {
  return authClient().get(`${API}/cupon/count`)
}

// Get all Cupones
export const getCupones = () => {
  return authClient().get(`${API}/cupon`)
}

// Get Cupon by id
export const getCuponById = (id) => {
  return authClient().get(`${API}/cupon/${id}`)
}

// Get Cupon by code
export const getCuponByCode = (code) => {
  return authClient().get(`${API}/cupon/code/${code}`)
}

// Update Cupon
export const updateCupon = (id, cupon) => {
  return authClient().put(`${API}/cupon/${id}`, cupon)
}

// Create Cupon
export const postCupon = (cupon) => {
  return authClient().post(`${API}/cupon`, cupon)
}

// Delete Cupon
export const deleteCupon = (id) => {
  return authClient().delete(`${API}/cupon/${id}`)
}

// Increment use count
export const incrementCuponUse = (id) => {
  return authClient().put(`${API}/cupon/${id}/increment-use`)
}

